export default function Camera(props: any) {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_9728_20418)">
                <path
                    d="M6 29.25C5.17157 29.25 4.5 28.5784 4.5 27.75V12C4.5 11.1716 5.17157 10.5 6 10.5H11.8636L14.0221 7.20234C14.2069 6.92008 14.5215 6.75 14.8588 6.75H21.1412C21.4785 6.75 21.7931 6.92008 21.9779 7.20234L24.1364 10.5H30C30.8284 10.5 31.5 11.1716 31.5 12V27.75C31.5 28.5784 30.8284 29.25 30 29.25H6Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <circle cx="27" cy="14.625" r="1.125" fill="black" />
                <path
                    d="M18 24.75C21.1067 24.75 23.625 22.2317 23.625 19.125C23.625 16.0183 21.1067 13.5 18 13.5C14.8933 13.5 12.375 16.0183 12.375 19.125C12.375 22.2317 14.8933 24.75 18 24.75Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_9728_20418">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
